import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

const AdminRoute = ({ children }) => {
  const { isAuthenticated, isLoading, user } = useAuth();
  const location = useLocation();

  if (isLoading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 dark:bg-gray-900">
        <div className="text-center">
          <img
            src="/logo_black.webp"
            alt="OKIO"
            className="h-8 w-auto mx-auto mb-4 dark:hidden"
          />
          <img
            src="/logo_white.webp"
            alt="OKIO"
            className="h-8 w-auto mx-auto mb-4 hidden dark:block"
          />
          <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-gray-900 dark:border-gray-300 mx-auto"></div>
        </div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  if (!user?.isSuperuser) {
    return <Navigate to="/" replace />;
  }

  return children;
};

export default AdminRoute;


